<template>
  <b-container>
    <div>
      <div>
        <success-fade-alert ref="alert" :msg="$t('checklist.fill.success')" />
        <fade-alert-danger ref="fadeAlertDanger" :msg="alert.error" />
      </div>
      <span class="text-danger" v-if="modelstate['FormId']">
        {{ modelstate["FormId"] }}
      </span>
      <!-- {{ modelstate }} -->

      <b-form @submit.prevent="processForm">
        <b-row>
          <b-col :lg="lg" :md="md" :sm="sm">
            <form-fill-fields
              :autosave-values="autosaveValues"
              :checklist="checklist"
              :values="checklist.values"
              :modelstate="modelstate"
              :token="token"
            >
            </form-fill-fields
          ></b-col>
        </b-row>

        <div class="field has-text-right">
          <b-button
            variant="primary"
            :disabled="submitted"
            @click="FinishFilling"
          >
            {{ $t("checklist.fill.finishFill") }}
          </b-button>
          <br />
          <b-button
            v-if="isSharedFill == false"
            variant="primary"
            :disabled="submitted"
            @click="SaveDraft"
          >
            {{ $t("checklist.fill.saveDraft") }}
          </b-button>
        </div>
      </b-form>
    </div>

    <!-- <pre class="language-json"><code>{{ checklist  }}</code></pre> -->
    <!-- <div>{{ modelstate }}</div> -->
    <!-- <div>{{ checklist }}</div> -->
  </b-container>
</template>

<script>
import { extend } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";
extend("required", required);

import axios from "axios";
import AwesomeMask from "awesome-mask";
import { openDB } from "idb";

export default {
  name: "Fill",
  components: {
    FadeAlertDanger: () => import("@/components/FadeAlertDanger.vue"),
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
    FormFillFields: () =>
      import("@/components_rms/checklist/form/FormFillFields.vue"),
  },
  directives: {
    mask: AwesomeMask,
  },
  props: {
    checklist: {
      description: "Checklist",
      type: Object,
      default: function () {
        return {
          id: 0,
          formId: 0,
          formName: "",
          draft: false,
          values: [
            {
              fieldId: 0,
              fieldName: "",
              fieldTip: "",
              fieldType: 6,
              allowsAttachment: false,
              required: false,
              value: "",
              options: null,
              attachments: [],
            },
          ],
        };
      },
    },
    token: {
      description: "Token de acesso",
      type: String,
      required: true,
    },
    lg: {
      description: "LG",
      type: String,
      default: "6",
    },
    md: {
      description: "MD",
      type: String,
      default: "6",
    },
    sm: {
      description: "Small",
      type: String,
      default: "12",
    },
    isSharedFill: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      alert: {
        error: "",
      },
      autosaveIsProcessing: false,
      autosaveTimer: null,
      autosaveValues: [],
      inputChangeDebounce: 5000,
      modelstate: {},
      submitted: false,
    };
  },
  created: function () {
    // if (this.checklist) {
    //   if (this.checklist.id == 0 || this.checklist.draft) {
    //     this.autosaveTimer = setInterval(
    //       this.autosaveVerify,
    //       this.inputChangeDebounce
    //     ); // mudar para 5s
    //   }
    // }
  },
  beforeDestroy: function () {
    clearInterval(this.autosaveTimer);
    console.log("Checkfill - beforeDestroy");
    this.autosaveFinish();
  },
  methods: {
    async autosaveFinish() {
      while (this.autosaveIsProcessing == true) {
        await this.sleep(1000);
      }
      this.autosaveProcess();
    },
    async autosaveProcess() {
      try {
        if (this.submitted) {
          console.log("autosaveProcess submitted");
          return;
        }

        if (this.autosaveValues.length == 0) {
          console.log("autosaveProcess lenght == 0");
          return;
        }

        if (this.checklist.id == 0 || this.checklist.draft) {
          console.log("autosaveProcess - saving");

          this.autosaveIsProcessing = true;

          if (this.isSharedFill == true) {
            this.autosaveIndexedDb(this.checklist);
          } else {
            const values = this.autosaveValues;
            const draftCheckList = this.createAutoSaveDraft();
            const checklistFormData =
              this.createChecklistFormData(draftCheckList);

            const response = await axios.request({
              url: `${this.$store.getters.urlChecklist}/v8/checklist/save?returnAttachmentContent=false&loadIntegrations=false`,
              method: "POST",
              headers: {
                "Content-Type": "multipart/form-data",
                Authorization: `Bearer ${this.token}`,
              },
              data: checklistFormData,
            });

            console.log("autosaveProcess - response");
            console.log(response);
            console.log(response.data);
            this.checklist.id = response.data.id;
            // Values
            response.data.values.forEach((responseValue) => {
              values.forEach((value) => {
                if (responseValue.fieldId == value.fieldId) {
                  value.id = responseValue.id;
                  // Attachments
                  if (responseValue.attachments) {
                    responseValue.attachments.forEach((responseAttach) => {
                      value.attachments.forEach((attach) => {
                        if (
                          responseAttach.attachmentName == attach.attachmentName
                        ) {
                          attach.id = responseAttach.id;
                        }
                      });
                    });
                  }
                }
              });
            });
            this.submitted = false;
          }
          this.autosaveIsProcessing = false;
        }
      } catch (error) {
        this.autosaveIsProcessing = false;
        this.submitted = false;
        console.log(error);
        if (error.response) {
          console.log(error.response.data.errors);
          if (error.response.status == 400) {
            this.modelstate = error.response.response;
          } else if (
            error.response.status == 401 &&
            this.isSharedFill == false
          ) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            this.modelstate = error.response.data.errors;
          }
        }
      }
    },
    autosaveVerify() {
      if (this.autosaveIsProcessing == true) {
        return;
      }
      this.autosaveProcess();
    },
    createAutoSaveDraft() {
      let values = this.autosaveValues;
      this.checklist.values.forEach((item) => {
        if (item.fieldType == 8) {
          if (item.id == 0) {
            values.push(item);
          }
        }
      });

      this.autosaveValues = [];

      this.submitted = true;
      this.checklist.draft = true;

      let draftCheckList = {
        id: this.checklist.id,
        guid: this.checklist.guid,
        formId: this.checklist.formId,
        formName: this.checklist.formName,
        draft: this.checklist.draft,
        dateFill: null,
        values: [],
      };

      values.forEach((item) => {
        let draftValue = {
          id: item.id,
          displaySequence: item.displaySequence,
          fieldId: item.fieldId,
          fieldName: item.fieldName,
          fieldTip: item.fieldTip,
          fieldType: item.fieldType,
          allowsAttachment: item.allowsAttachment,
          required: item.required,
          value: item.value,
          // attachment: item.attachment,
          attachments: item.attachments,
          anomaly: item.anomaly,
          options: null,
        };

        if (item.options) {
          draftValue.options = [];
          item.options.forEach((element) => {
            draftValue.options.push({
              value: element.value,
              text: element.text,
              anomaly: element.anomaly,
              additional: null,
            });
          });
        }

        draftCheckList.values.push(draftValue);
      });
      return draftCheckList;
    },
    createChecklistFormData(checklist) {
      const checklistFormData = this.jsonToFormData(checklist);

      // Remover anexos do objeto checklist no FormData
      // for (const key of checklistFormData.keys()) {
      //   if (key.includes("[attachment]")) {
      //     checklistFormData.set(key, null);
      //   }
      // }

      const attachmentsList = this.getFormDataAttachments(checklist.values);
      if (attachmentsList.length > 0) {
        for (const attachment of attachmentsList) {
          checklistFormData.append(
            `files`,
            attachment.blobAttachment,
            attachment.attachmentName
          );
        }
      }

      return checklistFormData;
    },
    getFormDataAttachments(checklistValuesList) {
      if (checklistValuesList == null) {
        return [];
      }

      let attachments = [];
      // console.log(checklistValuesList);
      for (let checklistValue of checklistValuesList) {
        for (let checklistAttachment of checklistValue.attachments ?? []) {
          if (checklistAttachment.id == null) {
            if (checklistAttachment.attachment != "") {
              let blobAttachment = this.base64ToBlob(
                checklistAttachment.attachment
              );

              attachments.push({
                blobAttachment: blobAttachment,
                attachmentName: checklistAttachment.attachmentName,
              });
            }
          }
        }

        for (let option of checklistValue.options ?? []) {
          let additionalAttachmentsList = this.getFormDataAttachments(
            option.additional
          );
          for (let additionalAttachment of additionalAttachmentsList ?? []) {
            attachments.push(additionalAttachment);
          }
        }
      }

      return attachments;
    },
    async FinishFilling() {
      try {
        this.modelstate = {};
        this.submitted = true;
        this.checklist.draft = false;
        this.checklist.dateFill = null;
        const checklistFormData = this.createChecklistFormData(this.checklist);

        // ivan 20240206
        // https://masteringjs.io/tutorials/axios/form-data
        const response = await axios.request({
          url: `${this.$store.getters.urlChecklist}/v8/checklist/save?returnAttachmentContent=false&loadIntegrations=false`,
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.token}`,
          },
          data: checklistFormData,
        });
        if (response.status == 200) {
          this.autosaveValues = [];
          this.model = response.data;
          this.$refs.alert.show();
          this.$emit("finishFilling");
          this.$emit("fillingCheclistId", this.model.id);
          console.log(response.message);
        } else {
          this.alert.error = response.title;
          this.$refs.fadeAlertDanger.show();
          console.log(response.message);
        }
        this.modelstate = {};
        this.submitted = false;
        window.scrollTo(0, 0);
        await this.clearIndexedDB();
      } catch (error) {
        this.submitted = false;

        if (!error.response) {
          this.alert.error = error.message;
        } else {
          switch (error.response.status) {
            case 401:
              this.$store.dispatch("logout").then(() => {
                this.$router.push("/login");
              });
              break;

            case 400:
              this.modelstate = error.response.data.errors ?? {};
              this.alert.error =
                error.response.data.title ==
                "One or more validation errors occurred."
                  ? this.$t("geral.reviewValues")
                  : error.response.data.title;

              if (error.response.data.data) {
                this.checklist.id = error.response.data.data.id;
                for (let valueResponse of error.response.data.data.values) {
                  for (let checklistValue of this.checklist.values.filter(
                    (checklistValue) =>
                      valueResponse.fieldId == checklistValue.fieldId
                  )) {
                    checklistValue.id = valueResponse.id;
                  }
                }
              }
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
              break;

            default:
              this.modelstate = error.response.response;
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
              this.$refs.fadeAlertDanger.show();
              window.scrollTo(0, 0);
              break;
          }
        }
      }
    },
    getAditionalFields(field) {
      let fields = [];
      if (field.value != null) {
        if (field.options != null) {
          for (let opt of field.options) {
            if (opt.value == field.value) {
              if (opt.additional != null) {
                for (let aditionalField of opt.additional) {
                  fields.push(aditionalField);
                }
              }
            }
          }
        }
      }
      return fields;
    },
    handleFileUpload(event, object) {
      const fileElement = event.target;
      const file = fileElement.files[0];
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => {
          // convert image file to base64 string
          object.attachment = reader.result;
          this.onDataChange(object);
        },
        false
      );

      if (file) {
        reader.readAsDataURL(file);
      }
    },
    async SaveDraft() {
      try {
        this.submitted = true;
        this.checklist.draft = true;
        this.checklist.dateFill = null;
        const checklistFormData = this.createChecklistFormData(this.checklist);

        const response = await axios.request({
          url: `${this.$store.getters.urlChecklist}/v8/checklist/save?returnAttachmentContent=false&loadIntegrations=false`,
          method: "POST",
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.token}`,
          },
          data: checklistFormData,
        });

        let responseChecklist = response.data;
        this.checklist.id = responseChecklist.id;

        // Values
        responseChecklist.values.forEach((responseValue) => {
          this.checklist.values.forEach((value) => {
            if (responseValue.fieldId == value.fieldId) {
              value.id = responseValue.id;
              // Attachments
              if (responseValue.attachments) {
                responseValue.attachments.forEach((responseAttach) => {
                  value.attachments.forEach((attach) => {
                    if (
                      responseAttach.attachmentName == attach.attachmentName
                    ) {
                      attach.id = responseAttach.id;
                    }
                  });
                });
              }
            }
          });
        });
        this.$refs.alert.show();
        this.submitted = false;
      } catch (error) {
        this.submitted = false;
        console.log(error);
        console.log(error.response.data.errors);

        if (!error.response) {
          this.alert.error = error.message;
        } else {
          switch (error.response.status) {
            case 401:
              if (this.isSharedFill == false) {
                this.$store.dispatch("logout").then(() => {
                  this.$router.push("/login");
                });
                break;
              }

              this.modelstate = error.response.data.errors;
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
              this.$refs.fadeAlertDanger.show();
              break;

            case 400:
              this.modelstate = error.response.data.errors;
              this.alert.error = this.$t("geral.reviewValues");

              if (error.response.data.data) {
                this.checklist.id = error.response.data.data.id;
                for (let valueResponse of error.response.data.data.values) {
                  for (let checklistValue of this.checklist.values.filter(
                    (checklistValue) =>
                      valueResponse.fieldId == checklistValue.fieldId
                  )) {
                    checklistValue.id = valueResponse.id;
                  }
                }
              }
              this.$refs.fadeAlertDanger.show();
              break;
            default:
              this.modelstate = error.response.response;
              if (error.response.data) {
                this.alert.error = error.response.data.errors;
              } else {
                this.alert.error = `${error.response.status} - ${error.response.statusText} `;
              }
              this.$refs.fadeAlertDanger.show();
              break;
          }
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async onDataChange(item) {
      if (this.autosaveTimer) {
        if (this.checklist.id == 0 || this.checklist.draft) {
          if (this.autosaveValues.indexOf(item) < 0) {
            this.autosaveValues.push(item);
          }
        }
      }
    },
    updateImageSrc(originObject, newValue) {
      originObject.attachment = newValue;
      this.onDataChange(originObject);
      this.$forceUpdate();
    },
    async autosaveIndexedDb(checklist) {
      this.autosaveValues = [];
      if (!("indexedDB" in window)) {
        console.error("Este navegador não suporta IndexedDB");
        return;
      }

      const dbName = "checklistDB";
      const storeName = "drafts";
      const version = 1;
      // console.log("checklist ", checklist);

      try {
        const db = await openDB(dbName, version, {
          upgrade(db) {
            if (!db.objectStoreNames.contains(storeName)) {
              db.createObjectStore(storeName, { keyPath: "formId" });
            }
          },
        });

        const tx = db.transaction(storeName, "readwrite");
        const store = tx.objectStore(storeName);
        await store.put(checklist);
        await tx.complete;

        console.log("Checklist salvo no IndexedDB");
      } catch (error) {
        console.error("Erro ao acessar IndexedDB", error);
      }
    },
    async clearIndexedDB() {
      const dbName = "checklistDB";
      const storeName = "drafts";

      const dbRequest = indexedDB.open(dbName);

      dbRequest.onsuccess = (event) => {
        const db = event.target.result;
        const transaction = db.transaction([storeName], "readwrite");
        const objectStore = transaction.objectStore(storeName);
        const clearRequest = objectStore.clear();

        clearRequest.onsuccess = () => {
          console.log("IndexedDB limpo com sucesso.");
        };

        clearRequest.onerror = (error) => {
          console.error("Erro ao limpar IndexedDB:", error);
        };
      };

      dbRequest.onerror = (error) => {
        console.error("Erro ao abrir IndexedDB:", error);
      };
    },
  },
};
</script>
